module.exports = __webpack_public_path__ + "static/media/Doug_Leinen-Resume.56d2b2c1.pdf";